import { LedgerView } from "./LedgerView";

export function PurchasesPage() {
  return (
    <LedgerView
      title="Purchases"
      helperText="Real-money purchases — coin packages and VIP, both verified server-side against Google Play before being credited (see lib/play-billing.js)."
      fixedReasons={["iap_purchase", "vip_purchase"]}
    />
  );
}
